module.exports = __webpack_public_path__ + "static/media/dany_mqtt_protocol_en.63683337.md";